/* ============================================================
   HYPE SIDE — Página de liga, "A Tabela" (sections/hs-liga.liquid)

   · Estado: clube, equipamento e público (adulto/criança). Vai para o
     endereço (?clube=benfica&kit=alternativo&para=crianca) para um
     anúncio poder abrir a página já filtrada, e volta com o "voltar".
   · Clube escolhido → "balneário": só esse clube, em grande, e "Mais
     camisolas" também só desse clube. A escolha fica em hs_clubs
     (localStorage), o mesmo que a página inicial usa para abrir no teu clube.
   · Equipamento escolhido → galeria desse equipamento em todos os clubes.
   · As trocas usam View Transitions quando o browser tem e não se pede
     menos movimento; senão mudam logo.
   · "Mais camisolas": por épocas, 8 de cada vez.
   ============================================================ */

(function () {
  var KIT_IN = { principal: '1', alternativo: '2', terceiro: '3', especiais: '4' };
  var KIT_OUT = { '1': 'principal', '2': 'alternativo', '3': 'terceiro', '4': 'especiais' };
  var KIT_NAME = { '1': 'principais', '2': 'alternativos', '3': 'terceiros', '4': 'especiais' };
  var STEP = 8;

  function calm() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function all(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }
  function plural(n, one, many) {
    return n + ' ' + (n === 1 ? one : many);
  }

  function init(root) {
    if (!root || root.__hsl) return;
    root.__hsl = true;

    var dock = root.querySelector('[data-hsl-dock]');
    var table = root.querySelector('[data-hsl-table]');
    var rows = all(root, '[data-hsl-row]');
    var picks = all(root, '[data-hsl-club]');
    var kitBtns = all(root, '[data-hsl-kit]');
    var audBtns = all(root, '[data-hsl-aud]');
    var status = root.querySelector('[data-hsl-status]');
    var empty = root.querySelector('[data-hsl-empty]');
    var more = root.querySelector('[data-hsl-more]');
    var cards = all(root, '[data-hsl-card]');
    var tabs = all(root, '[data-hsl-tab]');
    var showMore = root.querySelector('[data-hsl-showmore]');
    var none = root.querySelector('[data-hsl-none]');
    var league = root.dataset.league || '';
    var audBox = root.querySelector('[data-hsl-audbox]');
    var totalEl = root.querySelector('[data-hsl-total]');
    var unitEl = root.querySelector('[data-hsl-unit]');
    var clearBtn = root.querySelector('[data-hsl-clear]');
    var pickRow = root.querySelector('[data-hsl-picks]');
    if (!audBox && dock) dock.querySelector('.hsl-dock__inner').classList.add('no-aud');
    var clubs = {};
    rows.forEach(function (r) {
      clubs[r.dataset.club] = r;
      r._a = r.dataset.hasA ? r.dataset.hasA.split(',').filter(Boolean) : [];
      r._k = r.dataset.hasK ? r.dataset.hasK.split(',').filter(Boolean) : [];
      r._meta = r.querySelector('[data-hsl-meta]');
      r._gap = r.querySelector('[data-hsl-gap]');
    });

    var state = { club: 'all', kit: 'all', aud: 'a', tab: 'all', shown: STEP };

    /* ---------- Endereço ---------- */
    function readUrl() {
      var p = new URLSearchParams(location.search);
      var c = p.get('clube');
      var k = (p.get('kit') || '').toLowerCase();
      var a = (p.get('para') || '').toLowerCase();
      state.club = c && clubs[c] ? c : 'all';
      state.kit = KIT_IN[k] && root.querySelector('[data-hsl-kit="' + KIT_IN[k] + '"]') ? KIT_IN[k] : 'all';
      state.aud = (a === 'crianca' || a === 'criança') && audBtns.length ? 'k' : 'a';
    }
    function writeUrl(push) {
      var p = new URLSearchParams(location.search);
      if (state.club !== 'all') p.set('clube', state.club); else p.delete('clube');
      if (state.kit !== 'all') p.set('kit', KIT_OUT[state.kit]); else p.delete('kit');
      if (state.aud === 'k') p.set('para', 'crianca'); else p.delete('para');
      var q = p.toString();
      var url = location.pathname + (q ? '?' + q : '') + location.hash;
      if (url === location.pathname + location.search + location.hash) return;
      history[push ? 'pushState' : 'replaceState']({ hsl: true }, '', url);
    }

    /* ---------- Aplicar o estado ---------- */
    function apply() {
      if (!table) return applyMore();
      table.dataset.kit = state.kit;
      table.dataset.aud = state.aud;
      table.classList.toggle('is-solo', state.club !== 'all');

      var visible = 0;
      rows.forEach(function (r) {
        var has = state.aud === 'k' ? r._k : r._a;
        var show = (state.club === 'all' || r.dataset.club === state.club) &&
          (state.kit === 'all' ? has.length > 0 || state.club === r.dataset.club : has.indexOf(state.kit) > -1);
        // Num clube sem a época nova (só "ainda não chegou") deixamos a linha à vista em "Todos"
        if (state.club === 'all' && state.kit === 'all' && !r._a.length && !r._k.length) show = state.aud === 'a';
        r.hidden = !show;
        if (show) visible++;
        all(r, '.hsl-kit').forEach(function (k) { k.hidden = k.dataset.aud !== state.aud; });
        // Clube escolhido sem nada para mostrar (ex.: sem versão criança): diz-se, não fica em branco
        if (r._gap) r._gap.hidden = !(show && (state.kit === 'all' ? !has.length : has.indexOf(state.kit) < 0));
        if (r._meta) {
          var n = has.length;
          r._meta.textContent = n ? plural(n, 'camisola', 'camisolas') + (state.aud === 'k' ? ' de criança' : '') : '';
        }
      });

      renderDock();
      if (empty) empty.hidden = visible > 0;

      if (status) {
        var who = state.club !== 'all' ? clubs[state.club].dataset.name : league;
        var what = state.kit === 'all' ? '' : KIT_NAME[state.kit];
        var kids = state.aud === 'k' ? ' de criança' : '';
        status.textContent = state.club !== 'all'
          ? who + (what ? ' · ' + what : '') + (state.aud === 'k' ? ' · criança' : '')
          : (what ? visible + ' ' + what + kids + ' da ' + league : plural(visible, 'clube', 'clubes') + kids);
      }

      var row = state.club !== 'all' ? clubs[state.club] : null;
      root.style.setProperty('--pick', row ? getComputedStyle(row).getPropertyValue('--c') : 'transparent');
      applyMore();
    }

    /* ---------- Doca: escolhas, números e indicadores ---------- */
    // Quantas camisolas da tabela se veem com este clube, equipamento e público
    function count(club, kit, aud) {
      var n = 0;
      rows.forEach(function (r) {
        if (club !== 'all' && r.dataset.club !== club) return;
        var has = aud === 'k' ? r._k : r._a;
        n += kit === 'all' ? has.length : (has.indexOf(kit) > -1 ? 1 : 0);
      });
      return n;
    }
    function check(btns, attr, value) {
      btns.forEach(function (b) {
        var on = b.dataset[attr] === value;
        b.setAttribute('aria-checked', String(on));
        b.tabIndex = on ? 0 : -1;
      });
    }
    function setN(b, n, show) {
      var el = b.querySelector('[data-hsl-n]');
      if (el) el.textContent = show ? n : '';
      b.classList.toggle('is-zero', n === 0);
    }
    function renderDock() {
      if (!dock) return;
      check(picks, 'hslClub', state.club);
      check(kitBtns, 'hslKit', state.kit);
      check(audBtns, 'hslAud', state.aud);

      picks.forEach(function (b) {
        setN(b, count(b.dataset.hslClub, state.kit, state.aud), true);
      });
      kitBtns.forEach(function (b) {
        // Num clube escolhido os números seriam 0/1: chega esbater o que ele não tem
        setN(b, count(state.club, b.dataset.hslKit, state.aud), state.club === 'all');
      });
      audBtns.forEach(function (b) {
        setN(b, count(state.club, state.kit, b.dataset.hslAud), false);
      });
      if (audBox) audBox.dataset.on = state.aud;

      var total = count(state.club, state.kit, state.aud);
      if (totalEl) totalEl.textContent = total;
      if (unitEl) unitEl.textContent = total === 1 ? 'camisola' : 'camisolas';
      if (clearBtn) clearBtn.hidden = state.club === 'all' && state.kit === 'all' && state.aud === 'a';

      // O indicador do clube e a linha da doca vestem as cores do clube
      var on = root.querySelector('.hsl-club[aria-checked="true"]');
      var cs = on && state.club !== 'all' ? getComputedStyle(on) : null;
      dock.style.setProperty('--hsl-pick', cs ? cs.getPropertyValue('--c') : '');
      dock.style.setProperty('--hsl-pick2', cs ? cs.getPropertyValue('--c2') : '');
      dock.classList.toggle('has-club', !!cs);
      placeAll();
    }

    /* Indicador que desliza até à escolha */
    function place(group) {
      var ind = group.querySelector(':scope > .hsl-ind');
      var on = group.querySelector('[aria-checked="true"]');
      if (!ind || !on || !on.offsetWidth) return;
      ind.style.width = on.offsetWidth + 'px';
      ind.style.height = on.offsetHeight + 'px';
      ind.style.transform = 'translate(' + on.offsetLeft + 'px,' + on.offsetTop + 'px)';
      if (!ind.classList.contains('is-ready')) {
        // primeira vez: aparece já no sítio, sem deslizar desde o canto
        ind.style.transition = 'none';
        void ind.offsetWidth;
        ind.style.transition = '';
        ind.classList.add('is-ready');
      }
    }
    function placeAll() {
      if (!dock) return;
      all(dock, '[role="radiogroup"]').forEach(place);
      if (pickRow) pickRow.classList.toggle('is-over', pickRow.scrollWidth > pickRow.clientWidth + 1);
    }

    /* ---------- Mais camisolas ---------- */
    function applyMore() {
      if (!more) return;
      var counts = {};
      var matches = [];
      cards.forEach(function (c) {
        var ok = state.club === 'all' || c.dataset.club === state.club;
        // Adulto/criança também filtra aqui, para quem procura criança não ver adulto
        if (audBtns.length) ok = ok && c.dataset.aud === state.aud;
        if (ok) {
          counts[c.dataset.tab] = (counts[c.dataset.tab] || 0) + 1;
          counts.all = (counts.all || 0) + 1;
        }
        c._ok = ok;
      });
      if (state.tab !== 'all' && !counts[state.tab]) state.tab = 'all';
      tabs.forEach(function (t) {
        var n = counts[t.dataset.hslTab] || 0;
        var small = t.querySelector('small');
        if (small) small.textContent = n;
        t.classList.toggle('is-zero', n === 0 && t.dataset.hslTab !== 'all');
        t.setAttribute('aria-pressed', String(t.dataset.hslTab === state.tab));
      });
      cards.forEach(function (c) {
        var inTab = c._ok && (state.tab === 'all' || c.dataset.tab === state.tab);
        if (inTab) matches.push(c);
        c.hidden = true;
      });
      matches.forEach(function (c, i) {
        var was = c.hidden;
        c.hidden = i >= state.shown;
        if (was && !c.hidden && c._seen) c.classList.add('is-new');
        c._seen = true;
      });
      more.hidden = matches.length === 0 && state.club === 'all';
      if (none) none.hidden = matches.length > 0;
      if (showMore) {
        var left = matches.length - state.shown;
        showMore.hidden = left <= 0;
        showMore.textContent = 'Mostrar mais (' + left + ')';
      }
    }

    function change(fn, opts) {
      opts = opts || {};
      fn();
      writeUrl(opts.push);
      if (!calm() && document.startViewTransition && !document.hidden && rows.length < 40) {
        document.startViewTransition(apply);
      } else {
        apply();
      }
    }

    /* Se o utilizador já desceu, a tabela volta ao início depois de mudar */
    function keepInView() {
      if (!table || !dock) return;
      var limit = dock.getBoundingClientRect().bottom;
      if (table.getBoundingClientRect().top < limit - 4) {
        table.scrollIntoView({ behavior: calm() ? 'auto' : 'smooth', block: 'start' });
      }
    }

    picks.forEach(function (b) {
      b.addEventListener('click', function () {
        var c = b.dataset.hslClub;
        if (c === state.club) return;
        // Ao escolher um clube mostra-se o balneário inteiro (todos os equipamentos dele)
        change(function () { state.club = c; state.kit = 'all'; state.tab = 'all'; state.shown = STEP; }, { push: true });
        if (c !== 'all') {
          try { localStorage.setItem('hs_clubs', JSON.stringify([c])); } catch (e) {}
        }
        keepInView();
        centerPick();
      });
    });
    kitBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.dataset.hslKit;
        if (k === state.kit) return;
        change(function () { state.kit = k; });
        keepInView();
      });
    });
    audBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var a = b.dataset.hslAud;
        if (a === state.aud) return;
        change(function () { state.aud = a; state.shown = STEP; });
      });
    });
    var reset = root.querySelector('[data-hsl-reset]');
    if (reset) reset.addEventListener('click', function () {
      change(function () { state.club = 'all'; state.kit = 'all'; });
    });
    if (clearBtn) clearBtn.addEventListener('click', function () {
      change(function () { state.club = 'all'; state.kit = 'all'; state.aud = 'a'; state.tab = 'all'; state.shown = STEP; }, { push: true });
      centerPick();
      var first = root.querySelector('.hsl-club--all');
      if (first) first.focus();
    });

    // Grupos de escolha (radiogroup): as setas mudam a escolha, Home/End vão aos extremos
    if (dock) dock.addEventListener('keydown', function (e) {
      var opt = e.target.closest('[role="radio"]');
      if (!opt) return;
      var opts = all(opt.closest('[role="radiogroup"]'), '[role="radio"]');
      var i = opts.indexOf(opt);
      var j = -1;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % opts.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + opts.length) % opts.length;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = opts.length - 1;
      if (j < 0) return;
      e.preventDefault();
      opts[j].focus();
      opts[j].click();
    });
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        state.tab = t.dataset.hslTab;
        state.shown = STEP;
        applyMore();
      });
    });
    if (showMore) showMore.addEventListener('click', function () {
      state.shown += STEP * 2;
      applyMore();
    });

    window.addEventListener('popstate', function () {
      readUrl();
      apply();
      centerPick();
    });

    /* ---------- Fila de escudos: o escolhido fica à vista ---------- */
    function centerPick(instant) {
      if (!pickRow || pickRow.scrollWidth <= pickRow.clientWidth) return;
      var b = root.querySelector('[data-hsl-club="' + state.club + '"]');
      if (!b) return;
      var x = b.offsetLeft - (pickRow.clientWidth - b.offsetWidth) / 2;
      pickRow.scrollTo({ left: Math.max(0, x), behavior: instant || calm() ? 'auto' : 'smooth' });
    }

    /* ---------- "O teu clube": ponto verde no escudo (não filtra sozinho) ---------- */
    try {
      var seen = JSON.parse(localStorage.getItem('hs_clubs') || '[]');
      for (var i = 0; i < seen.length; i++) {
        var mine = root.querySelector('.hsl-club[data-hsl-club="' + seen[i] + '"]');
        if (mine) {
          mine.classList.add('is-mine');
          mine.setAttribute('title', 'O teu clube');
          break;
        }
      }
    } catch (e) {}

    /* ---------- Doca colada por baixo do cabeçalho ---------- */
    function measure() {
      if (!dock) return 0;
      var header = document.querySelector('.section-header');
      var top = 0;
      if (header) {
        var pos = getComputedStyle(header).position;
        if ((pos === 'sticky' || pos === 'fixed') && !header.classList.contains('shopify-section-header-hidden')) {
          top = header.offsetHeight;
        }
      }
      root.style.setProperty('--hsl-top', top + 'px');
      root.style.setProperty('--hsl-dock-h', dock.offsetHeight + 'px');
      return top;
    }
    var topNow = measure();
    var ticking = false;
    if (dock) {
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          dock.classList.toggle('is-stuck', dock.getBoundingClientRect().top <= topNow + 1 && window.scrollY > 0);
        });
      }, { passive: true });
      window.addEventListener('resize', function () { topNow = measure(); placeAll(); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeAll);
    }

    /* ---------- Entradas ---------- */
    if (!calm() && 'IntersectionObserver' in window && !(window.Shopify && window.Shopify.designMode)) {
      root.classList.add('is-motion');
      all(root, '.hsl-hero__scarf span').forEach(function (s, i) { s.style.setProperty('--i', i); });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.remove('is-pending');
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -6% 0px' });
      rows.forEach(function (r) {
        if (r.getBoundingClientRect().top > window.innerHeight) {
          r.classList.add('is-pending');
          io.observe(r);
        }
      });
    }

    readUrl();
    apply();
    centerPick(true);
  }

  function boot() {
    document.querySelectorAll('[data-hsl]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
